export class PaginationResponse {
  lastPage?: number;
  totalItemCount?: number;
}
